import { render, staticRenderFns } from "./logisticsDetails.vue?vue&type=template&id=f8a2894a&scoped=true&"
import script from "./logisticsDetails.vue?vue&type=script&lang=js&"
export * from "./logisticsDetails.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDetails.vue?vue&type=style&index=0&id=f8a2894a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a2894a",
  null
  
)

export default component.exports